import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function CoachSection() {
  return <section className="py-24 px-4 bg-[#1a0a2e] text-white" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#F5A623]" data-id="element-3">
          La metodología que lo hace posible
        </h2>

        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 mt-12 backdrop-blur-sm" data-id="element-4">
          <div className="w-32 h-32 mx-auto bg-white rounded-full mb-8 flex items-center justify-center shadow-xl p-3" data-id="element-5">
            <img src="https://cdn.magicpatterns.com/uploads/epnQ3hBBpCtFGqrR4vGcJE/LOGO_TRILOGY.png" alt="Trilogy Logo" className="w-full h-full object-contain" data-id="element-6" />
          </div>

          <div className="space-y-4 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-7">
            <strong className="text-white text-2xl block" data-id="element-8">TRILOGY</strong>
            <p className="text-[#F5A623] font-medium text-base md:text-lg" data-id="element-9">
              Centro de Transformación
            </p>
            <p className="pt-2" data-id="element-10">
              TRILOGY es un centro de transformación probado en 9 países y más
              de 12,000 personas. No vendemos motivación. No vendemos teoría.
              Creamos experiencias que le demuestran a tu mente — físicamente —
              que tus límites no son reales.
            </p>
            <p className="text-3xl pt-4 tracking-widest" data-id="element-11">
              🇨🇴 🇻🇪 🇨🇱 🇪🇨 🇵🇪 🇵🇦 🇩🇴 🇲🇽 🇺🇸
            </p>
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#F5A623] mt-20" data-id="element-12">
          Facilitado por el equipo TRILOGY
        </h2>

        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 mt-12 backdrop-blur-sm" data-id="element-13">
          <div className="w-32 h-32 mx-auto bg-gradient-to-br from-[#5B2D8E] to-[#F5A623] rounded-full mb-8 flex items-center justify-center text-4xl shadow-xl" data-id="element-14">
            🤝
          </div>

          <div className="space-y-4 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-15">
            <strong className="text-white text-2xl block" data-id="element-16">
              Equipo TRILOGY
            </strong>
            <p className="text-[#F5A623] font-medium text-base md:text-lg" data-id="element-17">
              Coaches certificados
            </p>
            <p className="pt-2" data-id="element-18">
              Coaches certificados con más de 10 años de experiencia acompañando
              personas en Latinoamérica y Estados Unidos. Cada facilitador de
              TRILOGY está entrenado para guiarte en cada paso de esta
              experiencia — con seguridad, con propósito y con toda la comunidad
              apoyándote.
            </p>
          </div>
        </div>

        <div className="mt-16" data-id="element-19">
          <CTAButton className="mb-2" data-id="element-20">🔥 RESERVA TU LUGAR</CTAButton>
          <p className="text-sm md:text-base text-[#F5A623] font-medium" data-id="element-21">
            $50 → $5 · 90% OFF · Solo por el Mes de la Mujer
          </p>
        </div>
      </div>
    </section>;
}